export default [

     {
          path: '/risk-control-type',
          name: 'RiskControlType',
          component: () => import("@/views/Page/RiskControlType/RiskControlType.vue"),
          meta: {
               title: 'Risk Control Type',
          },
     }
];